import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { http, money } from "@/lib/api";
import { useCart } from "@/lib/cart";
import { TID } from "@/lib/testIds";
import { toast } from "sonner";

export default function Products() {
  const [params] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [store, setStore] = useState({ currency_symbol: "₹" });
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);
  const { add } = useCart();

  const featured = params.get("featured");

  useEffect(() => {
    const qs = new URLSearchParams();
    if (featured) qs.set("featured", "true");
    if (q) qs.set("q", q);
    setLoading(true);
    http.get(`/store/products?${qs.toString()}`).then((r) => { setProducts(r.data); setLoading(false); });
  }, [featured, q]);

  useEffect(() => {
    http.get("/store/info").then((r) => setStore(r.data));
  }, []);

  return (
    <div className="py-16 bls-container">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-10">
        <div>
          <span className="text-xs font-semibold uppercase tracking-widest text-[#7f77dd]">Shop</span>
          <h1 className="mt-2 font-display text-4xl sm:text-5xl font-bold tracking-tighter">
            All products
          </h1>
          <p className="mt-2 text-black/55">Things we genuinely use, recommended without the fluff.</p>
        </div>
        <input
          type="text"
          placeholder="Search products…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          className="bls-input max-w-xs"
          data-testid="products-search-input"
        />
      </div>

      {loading ? (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {Array.from({ length: 8 }).map((_, i) => <div key={i} className="bls-shimmer h-72 rounded-2xl" />)}
        </div>
      ) : products.length === 0 ? (
        <div className="text-center py-24 text-black/50">No products found.</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {products.map((p) => (
            <div key={p.id} className="bls-card overflow-hidden group" data-testid={`${TID.productCard}-${p.slug}`}>
              <Link to={`/product/${p.slug}`} className="block bls-thumb relative">
                {p.images?.[0] && <img src={p.images[0]} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />}
                {p.badge && <span className="absolute top-3 left-3 bls-tag bls-tag-green">{p.badge}</span>}
              </Link>
              <div className="p-5">
                <Link to={`/product/${p.slug}`}>
                  <h3 className="font-display font-bold text-lg leading-tight">{p.name}</h3>
                </Link>
                <p className="text-sm text-black/55 mt-1 line-clamp-2">{p.short_description}</p>
                <div className="mt-4 flex items-end justify-between">
                  <div>
                    <span className="font-display text-xl font-bold">{money(p.price, store.currency_symbol)}</span>
                    {p.compare_at_price && <span className="bls-old-price">{money(p.compare_at_price, store.currency_symbol)}</span>}
                  </div>
                  <button
                    onClick={() => { add(p); toast.success("Added to cart"); }}
                    className="px-3 py-2 rounded-full bg-[#16161f] text-white text-xs font-semibold hover:bg-[#534ab7] transition-colors"
                    data-testid={`${TID.productAddBtn}-${p.slug}`}
                  >
                    Add +
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
